import { z } from 'zod'

import { StringDtoSchema } from '@hcr/api/shared'

import { LinkDtoBaseSchema } from './LinkDtoBase'

export const LinkHeroDtoSchema = LinkDtoBaseSchema.extend({
  target: z.literal('external'),
  url: StringDtoSchema.url(),
})

export type LinkHeroDto = z.infer<typeof LinkHeroDtoSchema>

export const isLinkHeroDto = (x: unknown): x is LinkHeroDto => LinkHeroDtoSchema.safeParse(x).success
